var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortButtonArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00081 0.497429C3.1592 0.260501 3.5075 0.260502 3.66589 0.497429L5.8041 3.6959C5.98178 3.96169 5.79127 4.3182 5.47156 4.3182H1.19514C0.875429 4.3182 0.684919 3.96169 0.862601 3.6959L3.00081 0.497429Z",
    fill: "272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66716 9.50257C3.50877 9.7395 3.16047 9.7395 3.00208 9.50257L0.863873 6.3041C0.686191 6.03831 0.876701 5.6818 1.19641 5.6818L5.47283 5.6818C5.79254 5.6818 5.98305 6.03831 5.80537 6.3041L3.66716 9.50257Z",
    fill: "272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortButtonArrowIcon);
export default __webpack_public_path__ + "static/media/SortButtonArrowIcon.581bbf04dfbda053760b50ca8595cf07.svg";
export { ForwardRef as ReactComponent };